<template>
    <div v-if="showModalLocal">
        test
        <b-modal
            v-model="showModalLocal"
            :title="'Простой диалог'"
            class="modal-primary"
            size="lg"
            ok-variant="primary"
            @hide.prevent
            @cancel="handleCancel"
            @close="handleCancel"
            ref="my-modal"
        >

            <template v-if="booking.direct_payment">
                <h2>Прямая оплата в объекте размещения</h2>
            </template>
            <template v-else-if="booking.prebook">
                <h2>Предварительное бронирование</h2>
            </template>
            <template v-else-if="booking.wait_invoice_date">
                <h2>Счет ожидается</h2>
            </template>
            <template v-else>
                <h2>Счет № {{booking.bill_number }} от  {{ printDate(booking.bill_date) }}</h2>
            </template>


            <ul>
                <li>Заезд: {{ printDate(booking.start_at) }}</li>
                <li>Выезд: {{ printDate(booking.end_at) }}</li>

                <template v-if="booking.direct_payment">
                </template>
                <template v-else-if="booking.prebook">
                    <li>Ожидаемая дата поступления цен: {{ printDate(booking.wait_invoice_date) }}</li>
                </template>
                <template v-else-if="booking.wait_invoice_date">
                    <li>Ожидаемая дата поступления счета: {{ printDate(booking.wait_invoice_date) }}</li>
                </template>
                <template v-else>
                    <li>Сумма по счету: {{ formatPriceKop(booking.invoice_value) }} (<template v-if="booking.fee_included">сумма счета включает скидку</template><template v-else>сумма счета не включает скидку</template>)</li>
                    <li>Скидка: {{ formatPriceKop(booking.fee_value) }}</li>
                    <li>Сумма к оплате: <strong>{{ formatPriceKop(booking.to_pay_value) }}</strong></li>
                    <li>Крайняя дата оплаты счета: {{ printDate(booking.redemption_date) }}</li>
                </template>

                <li v-for="file in booking.files">
                    <a :href="file.path" target="_blank"><img :src="mimetypeicon32(file.mime_type)" :alt="file.mime_type">
                        <template v-if="file.type===CONSTANTS.BOOKING_FILETYPE_INVOICE"> Счет:</template>
                        <template v-if="file.type===CONSTANTS.BOOKING_FILETYPE_LETTER"> Письмо:</template>
                        {{file.orig_name}}
                    </a>
                </li>

            </ul>

            {{ booking }}

            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-secondary" @click="cancel()">
                    Закрыть
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import { functions_loaders } from '@/functions_loaders';
    import { functions_booking } from '@/functions/booking.js';
    import { functions } from '@/functions';
    import { functions_mimetypes } from '@/functions_mimetypes.js';


    export default {
        name: "BookingShowDialog",
        mixins: [functions_loaders, functions, functions_mimetypes, functions_booking],
        data: function () {
            return {
            };
        },
        model: {
            prop: "booking_id",
            event: "hide"
        },
        props: {
            booking_id: Number,
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", 0);
            },
            handleOk: function () {
                this.$emit("hide", 0);
            },
            handleSubmit: function () {
                this.$emit("hide", 0);
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.is(this.booking);
                },
                set: function (newValue) {}
            }
        },
        created: function() {
            let self = this;
            this.loadBooking(this.booking_id, function (self, payload) {
                self.booking.voucher = null;
                self.booking.data = null;
            }, self);
        },
        mounted: function() {
        },
        updated: function() {
        },
    }
</script>

<style scoped>

</style>
